import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

import {
	WithStyles,
	createStyles,
	Grid,
	Typography,
	Button,
	Link,
	FormControlLabel,
	Checkbox,
	Radio,
	FormControl,
	RadioGroup,
} from '@material-ui/core';
import { contentList } from '../__mocks__/contentList';
import CreateContentModals from './CreateContentModals';
import ContentTopMenu from './ContentTopMenu';
import { ContentListFilterData } from '../types/ContentFilterData';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import cx from 'classnames';

import CustomInfoIcon from '../../common/CustomInfoIcon';
import { MyPATDropdown, RePublishQueue } from '../../common';
import ACLService from '../../acl/services/aclService';
import { ACADEMIC_STAT, STAT_TYPE, STUDENT_TABS_VISIBLE, VALIDATION, VALIDATION_ACADEMIC } from '../constant/content';
import { checkCreateContentAccess, checkForTeacherUser, getPropertyValue, getQueryParams, getUserType } from '../../../utils';
import { USER_TYPE, VALIDATION_TYPE_CONSTANTS } from '../../../constants/comman';
import { withRouter } from 'react-router-dom';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import "../../../components/mylibrary/components/NewMenu.css";
import classNames from 'classnames';
import Select from 'react-select';


export const SHAREDWITHMEKAY = 'sharedwithme'
const filtersData = [{
	title: 'All Content',
	value: 'all',
}, {
	title: 'Created by me',
	value: VALIDATION.CREATED_BY_ME,
}, {
	title: 'Favourites',
	value: 'favourites',
}, {
	title: 'My Validations',
	value: VALIDATION.VALIDATION_REQUEST,
},
];

const styles = (theme: Theme) => createStyles({
	root: {
		padding: '2px 0px 8px',
	},
	tabMenuList: {
		margin: 0,
		padding: 0,
		paddingTop: 23,
	},
	menuPaddingLeft: {
		paddingLeft: '10px',
	},
	ulDefault: {
		padding: 0,
		margin: 7,
	},
	listItem: {
		display: 'inline-block',
		padding: 12,
		paddingTop: 0,
		paddingBottom: 0,
		position: 'relative',
		'&:first-child': {
			paddingLeft: 0,
		},
		'&.active::after': {
			content: "''",
			position: 'absolute',
			top: '-4px',
			right: 0,
			background: '#F13B3B',
			cursor: 'pointer',
			border: 'none',
			borderRadius: '50%',
			height: '8px',
			width: '8px',
			animation: 'ripple 1.5s linear infinite',
			transition: 'all 0.7s ease',
		},
	},
	"@keyframes ripple": {
		from: {
			boxShadow: '0 0 0 0 rgba(241, 59, 59, 0.3), 0 0 0 1px rgba(241, 59, 59, 0.3)',
		},
		to: {
			boxShadow: '0 0 0 0 rgba(241, 59, 59, 0.3), 0 0 0 4px rgba(241, 59, 59, 0.3)',
		},
	},
	linkItem: {
		...theme.typography.body1,
		color: '#999',
		textDecoration: 'none',
		fontSize: '1.125rem',
		'font-weight': '400',
		cursor:'pointer',
		'&:active, &:focus, &:hover': {
			color: '#1d7dea',
			textDecoration: 'none',
			opacity: 1,
			lineHeight: '20px',
			fontWeight: 700
		},
		'&.active, &:active': {
			color: '#1d7dea',
			textDecoration: 'none',
			opacity: 1,
			lineHeight: '20px',
			fontWeight: 700,
			borderBottom: '3px solid #1d7dea',
			paddingBottom:12,
		}
	},
	navTitle: {
		fontWeight: 600,
		fontSize: 28,
		lineHeight: 'normal',
		color: '#333333',
		padding: '0 20px',
	},
	fontStyleSM: {
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '1.125rem',
		lineHeight: '28px',
		alignItems: 'center',
		color: '#999999',
		opacity: 0.56
	},
	createContentButton: {
		marginRight: 6,
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '22px',
		padding: '11px 32px',
		height: 44
	},
	infoIcon: {
		marginLeft: -12,
		padding: 0,
		verticalAlign: '1.8px'
	},
	paddingLeft: {
		paddingLeft: 56
	},
	disableListItem: {
		'pointer-events': 'none',
	},
	bucketTabs: {
		borderRadius: 30,
		border: '1px solid #E6E6E6',
		background: '#FFF',
		boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.05)',
		padding: '5px 10px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	bucketItems: {
		color: '#666',
		fontSize: 14,
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: '28px',
		cursor: 'pointer',
		padding: '4px 15px',
		transition:'all .2s ease-in',
		borderRadius: 20,
		'&.active': {
			borderRadius: 20,
			background:'linear-gradient(182deg, rgba(29, 125, 234, 0.00) -108.72%, #1D7DEA 98.42%), rgba(29, 125, 234, 0.10)',
			color: '#ffffff',
			padding: '4px 10px',
			transition:'all .2s ease-in',
			'&:hover':{
				color:'#fff',
				'& i':{
					color:'#fff',
				},
			},
			'& i':{
				color:'#fff',
			},
		},
		'&:hover': {	
			color: '#1D7DEA',
			transition:'all .2s ease-in',
		},
		'& i':{
			fontSize:12,
			fontWeight:400,
			fontStyle:'normal',
			color:'#999',
		},
	},
	headerRgtCta: {
		display: 'flex',
	},
	bgWhiteNoPad:{
		background:'#fff',
		padding:'2px 0px 8px',
	},
	startNewValidate:{
		position:'relative',
		'z-index':'9991',
	},
	dropdownCustom:{
		position:'relative',
		left:0,
		top:0,
		'z-index':'9991',
		width:220,
		marginRight:20,
		'& button':{
			border:'solid 1px #1d7dea',
			padding:10,
			fontSize:16,
			lineHeight:'normal',
			borderRadius:4,
			background:'#fff',
			paddingRight:45,
			width:'100%',
			height:44,
			color:'#1d7dea',
			'&::after':{
				content:"''",
				height:44,
				width:1,
				background:'#1d7dea',
				position:'absolute',
				right:34,
				top:0,
				'z-index':'9992',
			},
			'& img':{
				height:44,
				width:17,
				position:'absolute',
				right:9,
				top:0,
				'z-index':'9992',

			},
		},

	},
	dropLists:{
		background:'#fff',
		padding:15,
		borderRadius:4,
		boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
		'& span':{
			display:'block',
			padding:'0 0 10px 0',
			cursor:'pointer',
			color:'#666',
			'&:hover':{
				color:'#1d7dea',
				'font-weight':'600',
			},
		},
	},
	basicSingle: {
		'width': '210px',
		'z-index': 2000,
		'margin-right': '20px',
		'& .validationSelect__control':{
			borderColor:'#1d7dea',
			'&:hover':{
				borderColor:'#1d7dea',
			},
			'& .css-tlfecz-indicatorContainer':{
				color:'#1d7dea',
			},
			'& .css-1okebmr-indicatorSeparator': {
				height: '100%',
				marginTop: 0,
				backgroundColor: '#1d7dea'
			},
			'& .css-1wa3eu0-placeholder':{
				color:'#1d7dea',
			},
		},
		
	},
	 
});

const colorStyles = {
	option: (styles: any) => {
		return {
			...styles,
			cursor: 'pointer',
			backgroundColor: '#ffffff',
			':hover': {
        		...styles[':hover'],
				backgroundColor: '#ffffff',
				color:'#1d7dea',
			}
		}
	},
	singleValue: (styles: any) => ({ ...styles,  color: '#1D7DEA' }),
	dropdownIndicator: (styles: any) => {
		return {
			...styles,
			color: '#1D7DEA',
			':hover':{
				...styles['.hover'],
				color:'#1d7dea',
			}
		}
	}
}
//@ts-ignore
interface ContentMenuProps extends WithStyles<typeof styles> {
	classes: any,
	isCreatedByMeEnabled: Boolean,
	contentMenuChanged: Function,
	selectedcontentMenu: string,
	contentCreateOption: Boolean;
	loggedInUserData: any,
	showLicenseExpiredDialog: any,
	isPostExpiryDays: any,
	toggleLicenseExpiredDialog: any,
	setLoggedInUser: any;
	bucketsToShow: any[];
	selectedBucketType: string;
	changeBucketType: Function;
	fromTestPaper: boolean;
	history: any;
	handleGoalsDrillerToggle: Function;
	academicYear: any;
	academicYearList: any;
	selectedAcademicYearList: any;
	handleAcademicYearChange: Function;
	handleFilterToggle: Function;
	filterContent: any;
	onStartValidation: Function;
	handleQuestionStatusChange: Function;
	bucketWiseCount: any;
	isOnyQuestionSelected: any;
	handleValidationInfoDialogOpen: Function;
}

interface ContentMenuState {
	selectedMenu: number,
	hasContent: Boolean,
	createContentOpen: Boolean,
	filterContent: ContentListFilterData,
	goals: any,
	isTooltip: boolean,
	isOpenRepublishDialog: boolean,
	isIndicator: boolean,
	tabStatus: any;
	showAcademicYearAlert: boolean;
	validationSelection: any;
}

class ContentMenu extends Component<ContentMenuProps, ContentMenuState>{

	constructor(props: ContentMenuProps, state: ContentMenuState) {
		super(props);

		this.state = {
			selectedMenu: 0,
			hasContent: true,
			createContentOpen: false,
			filterContent: {
				contentMenu: "all",
			},
			goals: [],
			isTooltip: false,
			isOpenRepublishDialog: false,
			isIndicator: false,
			tabStatus: {},
			showAcademicYearAlert: true,
			validationSelection: null
		}
		this.createContentOpenHandler = this.createContentOpenHandler.bind(this);
		this.createContentCloseHandler = this.createContentCloseHandler.bind(this);
		this.setSelectedMenu = this.setSelectedMenu.bind(this);
	}

	componentDidMount() {
		const studentUser = getUserType(USER_TYPE.STUDENT);
		const actionType = localStorage.getItem('actionType');
		actionType && localStorage.removeItem('actionType');
		if (actionType === 'createContent') {
			this.createContentOpenHandler();
		} else if (actionType === 'validationRequest') {
			const validationRequest = filtersData.findIndex((filterContent: any) => filterContent.value === VALIDATION.VALIDATION_REQUEST);
			this.setSelectedMenu(validationRequest);
		}

		contentRequestServices.getValidationTabStatus().then((res) => {
			const tabStatus = {
				[VALIDATION.CREATED_BY_ME]: res.createdByMe,
				[VALIDATION.VALIDATION_REQUEST]: res.validationRequest,
			};
			this.setState({ tabStatus });
		}
		)
		console.log('Content Validation');
	}


	createContentOpenHandler = (event?: any) => {

		if (this.props.isPostExpiryDays) {
			this.props.toggleLicenseExpiredDialog(true);
		} else {
			this.setState({
				createContentOpen: true
			});
		}
	};

	createContentCloseHandler = (event: any) => {
		this.setState({
			createContentOpen: false
		});
	};

	setSelectedMenu(index: number) {

		this.setState({ selectedMenu: index });
		if (this.props.contentMenuChanged) {
			this.props.contentMenuChanged(filtersData[index].value);
		}
	}

	handleRepublishQueue = (value: any, func?: any) => {

		if (this.props.isPostExpiryDays) {
			this.props.toggleLicenseExpiredDialog(true)
		} else {
			this.setState({
				isOpenRepublishDialog: value,
			}, () => {
				if (func) func()
			})
		}
	}

	afterLoadQueueData = (hasDataInQueue: boolean) => {
		this.setState({ isIndicator: hasDataInQueue })
	}

	isFilterApplied = () => {
		const { filterContent } = this.props;
		return (filterContent.contentFilterData || []).some((filterCatagory: any) => {
			return (filterCatagory.filters || []).some((filter: any) => {
				return filter.isSelected || (filter.filters || []).some((filter: any) => filter.isSelected);
			})
		})
	}

	getSelectedAcademicYears = (): string => {
		const {academicYearList, selectedAcademicYearList} = this.props;
		if(!academicYearList.length || !selectedAcademicYearList.length) return '';
		const startYear = selectedAcademicYearList[0], endYear = selectedAcademicYearList[selectedAcademicYearList.length - 1];
		if(academicYearList[0].key === endYear) {
			return academicYearList[0].label;
		}
		return `Academic Year ${startYear}-${endYear + 1}`;
	}

	render() {
		const { classes, selectedcontentMenu, contentCreateOption = true, isCreatedByMeEnabled, bucketsToShow, selectedBucketType, 
			changeBucketType, fromTestPaper, handleGoalsDrillerToggle, handleFilterToggle, academicYear, selectedAcademicYearList, 
			academicYearList, handleAcademicYearChange, filterContent, handleQuestionStatusChange, bucketWiseCount, isOnyQuestionSelected, 
			handleValidationInfoDialogOpen = () => {} } = this.props;
		const { selectedMenu, createContentOpen, isTooltip, isOpenRepublishDialog, isIndicator, tabStatus, showAcademicYearAlert, validationSelection } = this.state;
		const studentUser = getUserType(USER_TYPE.STUDENT);
		const isTeacher = checkForTeacherUser(null, true);
		const validationState: any = ACADEMIC_STAT[selectedcontentMenu] || {};
		const selectedAcademicYears = this.getSelectedAcademicYears();
		const showCreateContent = checkCreateContentAccess();
		const showContentValidationData = isTeacher && !studentUser && VALIDATION.TABS.includes((selectedcontentMenu)) && !fromTestPaper && isOnyQuestionSelected;
		
		return (
			<div className={classes.bgWhiteNoPad}>

				<div className="headerSticky">
					<div className="logoMainMenu">
						<div className="mainTitleTop">
							<Typography className={classes.navTitle}>My Library</Typography>
						</div>
						{studentUser ? 
							<Grid item xs={9}>
								<Grid container direction="row"
									justify="space-between"
									alignItems="center"
									spacing={24} className={classes.menuPaddingLeft}>
									<Grid item>
										<ul className={classes.tabMenuList}>
											{filtersData.map(({ title, value }, i) => {
												if (!STUDENT_TABS_VISIBLE.includes(value)) return null;
												return <>
													{
														<li key={value + i} className={classes.listItem}>
															<Link
																onClick={(e: any) => { e.preventDefault(); this.setSelectedMenu(i) }}
																className={cx(classes.linkItem, { 'active': selectedcontentMenu === value })}
															>
																{title}
															</Link>
														</li>
													}
													{
														value === 'favourites' && (
															<li className={[classes.listItem, classes.infoIcon].join(' ')}>
																<CustomInfoIcon
																	isCenterArrow={!isTooltip}
																	isRightArrow={false}
																	isInfoIcon={!isTooltip}
																	knowMoreAbout={false}
																	dialogTitle="Favourites"
																	imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
																	dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
																	details="Click to know more"
																	toolTipDirection="top" />
															</li>
														)
													}
												</>
											})}

										</ul>
									</Grid>
									<Grid item  className='studentSetRight'>
										<Button dir="rtl"
											className={classes.createContentButton}
											variant="contained"
											color="primary"
											onClick={this.createContentOpenHandler.bind(this)}
										>
											Create Question
										</Button>
										<CreateContentModals
											createContentOpen={createContentOpen}
											createContentCloseHandler={this.createContentCloseHandler.bind(this)}
										/>
									</Grid>
								</Grid>
							</Grid> :
							<>
								<div className='menuFirst'>
									<ul className={classes.tabMenuList}>
										{_.map(filtersData, ({ title, value }, i) => {
											if (fromTestPaper && (value === VALIDATION.VALIDATION_REQUEST)) return null;
											return (<>
												{(value !== VALIDATION.VALIDATION_REQUEST || isTeacher) && <li key={value + i} className={cx(classes.listItem, { 'active': tabStatus[value] })} >
													<Link
														onClick={(e: any) => { e.preventDefault(); this.setSelectedMenu(i) }}
														className={classes.linkItem + " " + (selectedcontentMenu == value ? 'active' : (isCreatedByMeEnabled ? classes.disableListItem : ''))}
													>
														{title}
													</Link>
												</li>}
												{/* {
													value === 'favourites' && (
														<li className={[classes.listItem, classes.infoIcon].join(' ')}>
															<CustomInfoIcon
																isCenterArrow={!isTooltip}
																isRightArrow={false}
																isInfoIcon={!isTooltip}
																knowMoreAbout={false}
																dialogTitle="Favourites"
																imageURL="/assets/svg/infoIcon/myLibrary/favourite.svg"
																dialogPara="You can view the content marked as “Favourite” by you in this tab. You can mark any content as “Favourite” by clicking on the star icon next to it."
																details="Click to know more"
																toolTipDirection="top" />
														</li>
													)
												} */}
											</>
										)})}
									</ul>
								</div>
								<div className="newValidCreateContent">
									{!fromTestPaper && <>
										{isTeacher && 
										// <button className="startNewValid" onClick={() => this.props.onStartValidation()}>Start New Validation</button>
										// <div className={classes.startNewValidate}>
										// 		<div className={classes.dropdownCustom}>
										// 			<button>Start New Validation<img src="/assets/svg/myLibrary/primaryArrow.svg" alt="New Validation" /></button>
										// 			<div className={classes.dropLists}>
										// 				<span>Faculty Questions</span>
										// 				<span>Student Questions</span>
										// 			</div>
										// 		</div>
												
										// 	</div>
										<Select
											className={classes.basicSingle}
											classNamePrefix="validationSelect"
											name="validationType"
											options={VALIDATION_TYPE_CONSTANTS}
											isSearchable={false}
											isClearable={false}
											placeholder="Start New Validation"
											autoFocus={false}
											blurInputOnSelect={true}
											value={validationSelection}
											onChange={(ev: any) => {
												this.props.onStartValidation(ev);
												this.setState({ validationSelection: null });
											}}
											styles={colorStyles}
										/>
										}
										<div className={classes.headerRgtCta}>
											{contentCreateOption &&
												<>
													{showCreateContent &&
														<button className="createContentBtn" onClick={this.createContentOpenHandler.bind(this)}>
															Create Content
														</button>
													}
													<CreateContentModals
														createContentOpen={createContentOpen}
														createContentCloseHandler={this.createContentCloseHandler.bind(this)}
													/>
													<RePublishQueue
														afterLoadQueueData={this.afterLoadQueueData}
														handleRepublishQueue={this.handleRepublishQueue}
														isOpenRepublishDialog={isOpenRepublishDialog}
														isDisable={false} />
													<ContentTopMenu handleRepublishQueue={this.handleRepublishQueue} isIndicator={isIndicator} />
												</>
											}
										</div>
										</>
									}
								</div>
							</>
						}
					</div>
					{showContentValidationData &&
						<>
							{selectedAcademicYearList.includes(STAT_TYPE.VALIDATION_START) && showAcademicYearAlert &&
								<div className="notesAlert">
									Evaluation of the Questions Target and Submission commences as of March 1st, 2024
									<span className="closeAlert" onClick={() => this.setState({showAcademicYearAlert: false})}><img src="/assets/svg/notesAlertIcon.svg" alt="Close" /></span>
								</div>
							}
							<div className="blocksSelection">
								<div className="blocksBricks">
									<div className="targetBg">
										<b>{validationState.TARGET.LABEL}</b>
										<div className="infoIconv5" onClick={() => handleValidationInfoDialogOpen()}>
											<img src="assets/svg/infov5Icon.svg" alt="info" />
										</div>
										<span className="countsQuestions">{academicYear[validationState.TARGET.KEY]}</span>
									</div>
									{selectedcontentMenu === VALIDATION.CREATED_BY_ME &&
										<div className="contributionBg" onClick={() => handleValidationInfoDialogOpen()}>
											<b>{validationState.CONTRIBUTION.LABEL}</b>
											<div className="infoIconv5">
												<img src="assets/svg/infov5Icon.svg" alt="info" />
											</div>
											<span className="countsQuestions">{academicYear[validationState.CONTRIBUTION.KEY]}</span>
										</div>
									}
									<div className="submittedBg" onClick={()=> handleQuestionStatusChange(validationState.COMPLETED.KEY)}>
										<b>{validationState.COMPLETED.LABEL}</b>
										<FormControl className="customRadioMenu">
											<RadioGroup>
												<FormControlLabel control={<Radio checked={filterContent.questionStatus === validationState.COMPLETED.KEY} color="primary" />} label='' />
											</RadioGroup>
										</FormControl>
										<span className="countsQuestions">{academicYear[validationState.COMPLETED.KEY]}</span>
									</div>
									<div className="approvedBg" onClick={()=> handleQuestionStatusChange(validationState.APPROVED.KEY)}>
										<b>{validationState.APPROVED.LABEL}</b>
										<FormControl className="customRadioMenu">
											<RadioGroup>
												<FormControlLabel control={<Radio checked={filterContent.questionStatus === validationState.APPROVED.KEY} color="primary" />} label='' />
											</RadioGroup>
										</FormControl>
										<span className="countsQuestions">{academicYear[validationState.APPROVED.KEY]}</span>
									</div>
									<div className="rejectedBg" onClick={()=> handleQuestionStatusChange(validationState.REJECTED.KEY)}>
										<b>{validationState.REJECTED.LABEL}</b>
										<FormControl className="customRadioMenu">
											<RadioGroup>
												<FormControlLabel control={<Radio checked={filterContent.questionStatus === validationState.REJECTED.KEY} color="primary" />} label='' />
											</RadioGroup>
										</FormControl>
										<span className="countsQuestions">{academicYear[validationState.REJECTED.KEY]}</span>
									</div>
									<div className="reviewBg"  onClick={()=> handleQuestionStatusChange(validationState.REVIEW.KEY)}>
										<b>{validationState.REVIEW.LABEL}</b>
										<FormControl className="customRadioMenu">
											<RadioGroup>
												<FormControlLabel control={<Radio checked={filterContent.questionStatus === validationState.REVIEW.KEY} color="primary" />} label='' />
											</RadioGroup>
										</FormControl>
										<span className="countsQuestions">{academicYear[validationState.REVIEW.KEY]}</span>
									</div>
									{selectedcontentMenu === VALIDATION.CREATED_BY_ME && 
										<div className="draftBg" onClick={()=> handleQuestionStatusChange(validationState.DRAFT.KEY)}>
											<b>{validationState.DRAFT.LABEL}</b>
											<FormControl className="customRadioMenu">
												<RadioGroup>
													<FormControlLabel control={<Radio checked={filterContent.questionStatus === validationState.DRAFT.KEY} color="primary" />} label='' />
												</RadioGroup>
											</FormControl>
											<span className="countsQuestions">{academicYear[validationState.DRAFT.KEY]}</span>
										</div>
									}
									
								</div>
								<div className='dropdownTopMenu'>
								<MyPATDropdown
									// classes={{root: classes.dialogMain}}
									dropdownItems={academicYearList}
									selectedItem={selectedAcademicYearList}
									labelKey='label'
									valueKey='key'
									multiple
									isCustomCss={false}
									disableSearch
									onSelectedOption={handleAcademicYearChange}
									placeholder='Select Academic Year'
									customSelectedOption={selectedAcademicYears}
									/>
								</div>
							</div>
						</>
					}

					<div className={cx('bucketBrowseFilter', {'borderOn': bucketsToShow.length > 1 && showContentValidationData, 'studentCase': studentUser})}>
						{!studentUser &&
							<div className="bucketContainer">
								<Grid item className="topLinkContainer">
									{bucketsToShow.length > 1 ?
										<div className={classes.bucketTabs}>
											{(bucketsToShow || []).map(bucket =>
												(<span className={cx(classes.bucketItems, { 'active': bucket.value === selectedBucketType })} onClick={() => { changeBucketType(bucket.value) }} >{bucket.title} {bucketWiseCount[bucket.value] && <i>({bucketWiseCount[bucket.value]})</i>}</span>)
											)}
										</div>
										: <h4 className={classes.singleBucket} >{bucketsToShow[0].title}</h4>
									}
								</Grid>
							</div>
						}
						<div className="browseFilterBtn">
							{(!isOnyQuestionSelected || !isTeacher || studentUser) &&
								<div className='dropdownTopMenu'>
									<MyPATDropdown
									dropdownItems={academicYearList}
									selectedItem={selectedAcademicYearList}
									labelKey='label'
									valueKey='key'
									multiple
									isCustomCss={true}
									disableSearch
									onSelectedOption={handleAcademicYearChange}
									placeholder='Select Academic Year'
									customSelectedOption={selectedAcademicYears}
									/>
								</div>
							}
							{filterContent.contentMenu !== VALIDATION.VALIDATION_REQUEST &&<button className="browseTopicBtn" onClick={()=> handleGoalsDrillerToggle()} ><em className={cx({'filterOn': Object.keys(filterContent.goalsDriller || {}).length})}><img src="/assets/svg/browseTopicIcon.svg" alt='Browse By Topic' /></em> Browse By Topic</button>}
							<button className="filterBtn" onClick={()=> handleFilterToggle()}><em className= {cx({'filterOn': this.isFilterApplied()})}><img src="/assets/svg/browseFilterIcon.svg" alt='Filter' /></em> Filter</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	loggedInUserData:
		state.loginData.userData &&
		state.loginData.userData.loggedInUserData,
	showLicenseExpiredDialog:
		state.loginData.userData &&
		state.loginData.userData.showLicenseExpiredDialog,
	isPostExpiryDays:
		state.loginData.userData &&
		state.loginData.userData.isPostExpiryDays
});

const mapDispatchToProps = {
	toggleLicenseExpiredDialog,
	setLoggedInUser
};

// @ts-ignore
export default connect(
	mapStateToProps,
	mapDispatchToProps
	// @ts-ignore
)(withRouter(withStyles(styles)(ContentMenu)));